import { CollectionActionsProps, useDataSource, useSnackbarController } from "@firecms/core";
import { Button } from "@firecms/ui";

import { exportConnectionsToCSV, exportGoogleActionsEntitiesToCSV } from "./exportCollectionToCSV";

export function ExportCollectionAction({ collection }: CollectionActionsProps) {
  const snackbarController = useSnackbarController();
  const dataSource = useDataSource();

  const onClick = async () => {
    if (collection.id === "google_actions_entity") {
      await exportGoogleActionsEntitiesToCSV(collection, dataSource);
      snackbarController.open({
        type: "success",
        message: `Exported all entities from ${collection.name} as CSV.`,
      });
    } else if (collection.id === "connections") {
      await exportConnectionsToCSV(collection, dataSource);
      snackbarController.open({
        type: "success",
        message: `Exported all entities from ${collection.name} as CSV.`,
      });
    } else {
      snackbarController.open({
        type: "info",
        message: `Export not implemented for ${collection.name}`,
      });
    }
  };

  return (
    <Button onClick={onClick} color="primary" variant={"text"}>
      Export Collection
    </Button>
  );
}
